import {zLen} from "./stringhelpers";

export function formatDate(date) {
  return `${String(date.getUTCFullYear())}-${zLen(String(date.getUTCMonth() + 1), 2)}-${zLen(String(date.getUTCDate()), 2)}`;
}

export function formatDateLocal(date) {
  return `${String(date.getFullYear())}-${zLen(String(date.getMonth() + 1), 2)}-${zLen(String(date.getDate()), 2)}`;
}

export function formatTime(date) {
  return `${zLen(String(date.getUTCHours()), 2)}:${zLen(String(date.getUTCMinutes()), 2)}:${zLen(String(date.getUTCSeconds()), 2)}`;
}

export function formatTimeLocal(date) {
  return `${zLen(String(date.getHours()), 2)}:${zLen(String(date.getMinutes()), 2)}:${zLen(String(date.getSeconds()), 2)}`;
}

export function formatDateTimeLocal(date) {
  return `${formatDateLocal(date)} ${formatTimeLocal(date)}`;
}

export function formatDateTime(date) {
  return `${formatDate(date)} ${formatTime(date)}`;
}

export function makeDate(str) {
  if (!str) return null;
  return new Date(str);
}

export function makeDateObj(dateStr, hourNum = 0, minNum = 0) {
  if (!dateStr || dateStr.length === 0) return new Date();
  const newDate = new Date(dateStr);
  newDate.setUTCHours(hourNum, minNum);
  return newDate;
}

export function formatTimeFromEpoch(dateNumber) {
  let d = new Date(0);
  d.setTime((dateNumber - 3 * 3600) * 1000);
  return d;
}

export function formatUTCTimeFromEpoch(dateNumber) {
  let d = new Date(dateNumber * 1000);
  // d.setUTCDate((dateNumber) * 1000);
  return d;
}

export function displayMilHoursMinutesFromTime(date) {
  let timeSplit = date.toTimeString().split(":");
  return zLen(timeSplit[0], 2) + zLen(timeSplit[1]);
}

export function addHours(date, hours) {
  date.setHours(date.getHours() + hours);
  return date;
}

export function forceSingleTimeZone(date) {
  const localOffsetMinutes = (new Date()).getTimezoneOffset() - 300;
  date.setMinutes(date.getMinutes() + localOffsetMinutes);
  return date;
}

export function forceUTCTimeZone(date) {
  const localOffsetMinutes = (date).getTimezoneOffset();
  date.setMinutes(date.getMinutes() + localOffsetMinutes);
  return date;
}

export function getLocalOffset() {
  return (new Date()).getTimezoneOffset();
}

export function stdTimezoneOffset() {
  const now = new Date();
  const jan = new Date(now.getFullYear(), 0, 1);
  // console.log(jan.getTimezoneOffset());
  const jul = new Date(now.getFullYear(), 6, 1);
  // console.log(jul.getTimezoneOffset());
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

export function isInDaylightSavingTime(date) {
  return date.getTimezoneOffset() < stdTimezoneOffset();
  /*
  var today = new Date();
if (today.isDstObserved()) {
  alert ("Daylight saving time!");
}
   */
}

export function dstOffsetAtDate(dateInput) {
  var fullYear = dateInput.getFullYear() | 0;
  // "Leap Years are any year that can be exactly divided by 4 (2012, 2016, etc)
  //   except if it can be exactly divided by 100, then it isn't (2100,2200,etc)
  //    except if it can be exactly divided by 400, then it is (2000, 2400)"
  // (https://www.mathsisfun.com/leap-years.html).
  var isLeapYear = ((fullYear & 3) | (fullYear / 100 & 3)) === 0 ? 1 : 0;
  // (fullYear & 3) = (fullYear % 4), but faster
  //Alternative:var isLeapYear=(new Date(currentYear,1,29,12)).getDate()===29?1:0
  var fullMonth = dateInput.getMonth() | 0;
  return (
    // 1. We know what the time since the Epoch really is
    (+dateInput) // same as the dateInput.getTime() method
    // 2. We know what the time since the Epoch at the start of the year is
    - (+new Date(fullYear, 0, 0)) // day defaults to 1 if not explicitly zeroed
    // 3. Now, subtract what we would expect the time to be if daylight savings
    //      did not exist. This yields the time-offset due to daylight savings.
    - ((
      ((
        // Calculate the day of the year in the Gregorian calendar
        // The code below works based upon the facts of signed right shifts
        //    • (x) >> n: shifts n and fills in the n highest bits with 0s
        //    • (-x) >> n: shifts n and fills in the n highest bits with 1s
        // (This assumes that x is a positive integer)
        (31 & ((-fullMonth) >> 4)) + // January // (-11)>>4 = -1
        ((28 + isLeapYear) & ((1 - fullMonth) >> 4)) + // February
        (31 & ((2 - fullMonth) >> 4)) + // March
        (30 & ((3 - fullMonth) >> 4)) + // April
        (31 & ((4 - fullMonth) >> 4)) + // May
        (30 & ((5 - fullMonth) >> 4)) + // June
        (31 & ((6 - fullMonth) >> 4)) + // July
        (31 & ((7 - fullMonth) >> 4)) + // August
        (30 & ((8 - fullMonth) >> 4)) + // September
        (31 & ((9 - fullMonth) >> 4)) + // October
        (30 & ((10 - fullMonth) >> 4)) + // November
        // There are no months past December: the year rolls into the next.
        // Thus, fullMonth is 0-based, so it will never be 12 in Javascript

        (dateInput.getDate() | 0) // get day of the month

      ) & 0xffff) * 24 * 60 // 24 hours in a day, 60 minutes in an hour
      + (dateInput.getHours() & 0xff) * 60 // 60 minutes in an hour
      + (dateInput.getMinutes() & 0xff)
    ) | 0) * 60 * 1000 // 60 seconds in a minute * 1000 milliseconds in a second
    - (dateInput.getSeconds() & 0xff) * 1000 // 1000 milliseconds in a second
    - dateInput.getMilliseconds()
  );
}

export function parseSeconds(date, hh, mm, allDay, type) {
  const TZ = " -0800";
  try {
    let string = "" + date;
    if (allDay === true) {
      if (type === "start") {
        string += " 00:00:00";
      } else {
        string += " 23:45:00";
      }
    } else {
      string += " " + zLen(hh, 2) + ":" + zLen(mm, 2) + ":00";
    }
    const dated = Date.parse(string + TZ) / 1000;
    return dated
  } catch (e) {
    return Math.round((new Date()).getTime() / 1000);
  }
}


// WEBPACK FOOTER //
// ./src/util/datehelpers.js